var map = {
	"./contact-image.jpeg": 187,
	"./person-1.jpeg": 447,
	"./person-2.jpeg": 24,
	"./person-3.jpeg": 639,
	"./project-1.jpeg": 698,
	"./project-2.jpeg": 683,
	"./project-3.jpeg": 239,
	"./project-4.jpeg": 720,
	"./project-5.jpeg": 161,
	"./project-6.jpeg": 299,
	"./project-7.jpeg": 692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;